import { useReturnBarStore } from '@/stores/returnBar'

export default async function (to, from, next) {
    const returnBarStore = useReturnBarStore()
    returnBarStore.action.path = from.name
    next()
}
